import React from "react";

const PageHero = ({ eyebrow, title, intro, testid = "page-hero" }) => {
  return (
    <section
      className="border-b border-synergia-line"
      data-testid={testid}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 pt-24 md:pt-32 pb-20 md:pb-28">
        <div className="eyebrow animate-fade-in">{eyebrow}</div>
        <h1 className="mt-6 font-montserrat font-semibold text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-synergia-graphite max-w-4xl text-balance animate-fade-up">
          {title}
        </h1>
        <div className="hero-rule mt-10" />
        {intro && (
          <p
            className="mt-8 font-inter text-lg leading-relaxed text-synergia-graphite/75 max-w-3xl animate-fade-up"
            style={{ animationDelay: "120ms" }}
          >
            {intro}
          </p>
        )}
      </div>
    </section>
  );
};

export default PageHero;
